// Wraps a capped-height list with a thin, always-visible themed scrollbar
// (.themed-scrollbar, see index.css) — replaced an earlier animated
// chevron-hint version per explicit user feedback ("chevrons look bad").
export function ScrollableList({ maxHeightClass, innerClassName = "", children }) {
  return (
    <div className={`themed-scrollbar ${maxHeightClass} overflow-y-auto pr-1 ${innerClassName}`}>
      {children}
    </div>
  );
}
